import React from 'react'

import { CreateViewModal } from 'features/views/common/CreateViewModal'
import { CREATABLE_VIEW_TYPES } from 'features/views/common/viewTypes'

import { Box } from 'ui/components/Box'
import {
    Dropdown,
    DropdownButton,
    DropdownContent,
    DropdownHeadSearch,
    DropdownItem,
    DropdownItemLink,
    DropdownSeparator,
    DropdownSub,
    DropdownSubContent,
    DropdownSubTrigger,
} from 'ui/components/Dropdown'
import { FooterWrapperStyle } from 'ui/components/Menu/Menu.css'
import { Tag } from 'ui/components/Tag'
import { Body } from 'ui/components/Text'

import { useToolbarActionsViewsState } from './hooks/useToolbarActionsViewsState'

type ToolbarActionsViewsProps = {}

export const ToolbarActionsViews: React.FC<ToolbarActionsViewsProps> = () => {
    const {
        isEmpty,
        isLoading,
        isError,
        views,
        onViewSelected,
        createViewModalRef,
        allowAddNewView,
        addNewView,
        onAddNewView,
    } = useToolbarActionsViewsState()

    return (
        <>
            <Dropdown modal={false}>
                <DropdownButton
                    size="xs"
                    startIcon={{ name: 'LayoutPanelLeft' }}
                    isLoading={isLoading}
                    variant={isError ? 'critical' : 'ghost'}
                    endIcon={isError ? { name: 'AlertCircle' } : undefined}
                >
                    Views
                </DropdownButton>
                <DropdownContent
                    align="end"
                    side="bottom"
                    head={<DropdownHeadSearch />}
                    style={{
                        width: '300px',
                    }}
                    footer={
                        allowAddNewView && (
                            <Box className={FooterWrapperStyle}>
                                <DropdownSeparator />
                                <DropdownSub>
                                    <DropdownSubTrigger
                                        variant="action"
                                        startIcon={{ name: 'Plus' }}
                                        label="Add new list view"
                                    />
                                    <DropdownSubContent
                                        style={{ width: '200px', minWidth: '200px' }}
                                    >
                                        {Object.values(CREATABLE_VIEW_TYPES).map((v) => (
                                            <DropdownItem
                                                key={v.display}
                                                startIcon={{ name: v.icon }}
                                                label={v.label}
                                                onClick={() => addNewView(v.display)}
                                            />
                                        ))}
                                    </DropdownSubContent>
                                </DropdownSub>
                            </Box>
                        )
                    }
                >
                    {isError && (
                        <DropdownItem
                            label={
                                <Body color="textError">There was a problem displaying views</Body>
                            }
                            disabled
                        />
                    )}
                    {isEmpty && (
                        <DropdownItem
                            label={<Body color="textHelper">No views to show</Body>}
                            disabled
                        />
                    )}
                    {!isError &&
                        views.map((view) => (
                            <DropdownItemLink
                                key={view.url}
                                to={view.url}
                                label={view.label}
                                disabled={!view.url}
                                onClick={onViewSelected}
                                rightSlotContent={() => (
                                    <Tag
                                        size="2xs"
                                        color={view.typeAttrs.color}
                                        pointerEvents="none"
                                        disabled={!view.url}
                                    >
                                        {view.typeAttrs.label}
                                    </Tag>
                                )}
                            />
                        ))}
                </DropdownContent>
            </Dropdown>
            <CreateViewModal ref={createViewModalRef} onCreateView={onAddNewView} />
        </>
    )
}
